const { api } = require("@services/api");

export const getLoggedInDevices = () => api.get("/cpdb/get-loggedin-devices");

export const isDeviceActive = (deviceId) =>
  api.get(`/cpdb/is-device-active?device_id=${deviceId}`);

export const logoutLeader = (deviceId, source) => {
  const url = `/cpdb/logout-v2?device_id=${deviceId}&source=${source}`;
  return api.post(url);
};

export const confirmLeader = (uniqueDeviceId = "") =>
  api.post("/cpdb/confirm-device", { device_unique_id: uniqueDeviceId });

export const logOutCurrentDbDevice = (tl_id = "") => {
  return api.post("/cpdb/logout", { tl_id });
};
